import { Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

export default function BackButton(props) {
  const navigate = useNavigate();
  const handleBack = (e) => {
    e.preventDefault();
    navigate(-1);
  };

  return (
    <Button {...props} onClick={handleBack}>
      Back
    </Button>
  );
}
